import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

import type { ServiceMetric } from '../../types/report';

interface ServiceMetricsChartProps {
  careMetrics: ServiceMetric[];
  familyMetrics: ServiceMetric[];
}

export const ServiceMetricsChart = ({ careMetrics, familyMetrics }: ServiceMetricsChartProps) => {
  const comparisonData = [
    {
      name: '전체 가입률',
      케어: careMetrics.find((m) => m.key === 'totalCareRate')?.value || 0,
      패밀리: familyMetrics.find((m) => m.key === 'totalFamilyRate')?.value || 0,
    },
    {
      name: '매출 비중',
      케어: careMetrics.find((m) => m.key === 'careRevenueProportion')?.value || 0,
      패밀리: familyMetrics.find((m) => m.key === 'familyRevenueProportion')?.value || 0,
    },
  ];

  const careRateData = [
    {
      name: '신규 케어 가입률',
      value: careMetrics.find((m) => m.key === 'newContractCareRate')?.value || 0,
    },
    {
      name: '전체 케어 가입률',
      value: careMetrics.find((m) => m.key === 'totalCareRate')?.value || 0,
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h4 className="mb-4 text-sm font-medium text-gray-700">케어 vs 패밀리 서비스 비교</h4>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={comparisonData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip formatter={(value) => `${Number(value).toFixed(2)}%`} />
              <Bar dataKey="케어" fill="#3b82f6" radius={[4, 4, 0, 0]} />
              <Bar dataKey="패밀리" fill="#10b981" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div>
        <h4 className="mb-4 text-sm font-medium text-gray-700">신규 vs 전체 케어 가입률 비교</h4>
        <div className="h-48">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={careRateData} layout="vertical" margin={{ top: 20, right: 30, left: 120, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis type="number" domain={[0, 30]} tick={{ fontSize: 12 }} />
              <YAxis type="category" dataKey="name" tick={{ fontSize: 12 }} width={110} />
              <Tooltip formatter={(value) => `${Number(value).toFixed(2)}%`} />
              <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                <Cell fill="#3b82f6" />
                <Cell fill="#f97316" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <p className="text-xs text-gray-500 mt-2">
          신규 계약 케어 가입률이 전체 대비 약 1.84배 높아 크로스셀링 전략이 효과적입니다.
        </p>
      </div>
    </div>
  );
};
